function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_3788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 14,
    cy: 14,
    r: 13.75,
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M8.27344 18.8654V9.25H11.201L15.2145 14.9505L12.8379 14.9368L16.8987 9.25H19.7318V18.8654H16.458V16.5714C16.458 15.7473 16.4789 15.0055 16.5209 14.3462C16.5734 13.6868 16.6573 13.0321 16.7727 12.3819L17.1505 13.2473L14.4905 16.8462H13.4517L10.839 13.2473L11.2325 12.3819C11.3479 12.9954 11.4266 13.6273 11.4685 14.2775C11.521 14.9185 11.5472 15.6832 11.5472 16.5714V18.8654H8.27344Z",
    fill: "#140B29",
    style: {
      fill: "#140B29",
      fill: "color(display-p3 0.0784 0.0431 0.1608)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_3788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMature);
export default __webpack_public_path__ + "static/media/mature.5a34725c1d3d99eacc7cfab791377400.svg";
export { ForwardRef as ReactComponent };